import React from "react";
import { TForm, TFormValues } from "./types";
import { GuideContext } from "../../components/GatewayForm/GatewayForm.store";
import GuideStep from "./GuideStep";
import FormContextWrapper from "./config/FormContextWrapper";

type TGuideProps = {
  formConfig: TForm;
};

const Guide: React.FC<TGuideProps> = ({ formConfig }) => {
  const { setCurrentConfig, currentStep, toggleGatewayForm, analytics } =
    React.useContext(GuideContext);

  // allow anywhere on the site to toggle gateway form modal 
  window.toggleGatewayForm = toggleGatewayForm

  React.useEffect(() => {
    const shouldShow = formConfig.steps[currentStep];
    if (shouldShow) {
      analytics.formStarted(currentStep);
    }
  }, []);

  React.useEffect(() => {
    setCurrentConfig(formConfig);
  }, [formConfig, setCurrentConfig]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  React.useEffect(() => {
    const shouldShow = !!formConfig.steps[currentStep];
    if (shouldShow) {
      window.scrollTo(0, 0);
      document.body.style.overflowY = "hidden";
      document.body.style.position = "relative";
    } else {
      document.body.style.overflowY = "unset";
      document.body.style.position = "unset";
    }
  }, [formConfig.steps, currentStep]);

  if (formConfig.steps[currentStep] === undefined) {
    return <></>;
  } else
    return (
      <FormContextWrapper>
        <GuideStep />
      </FormContextWrapper>
    );
};

export default Guide;
